import opineoCert from 'assets/images/icons/opineo_certificat.svg';
import Image from 'atomic/image';
import { BadgeType } from 'interfaces/dealer-opinions.interface';
import React from 'react';
import './dealer-small-badges.scss';
import OpineoShield from './opineo-shield';

interface DealerSmallBadgesProps {
    isOpineoQuality?: boolean;
    authorizedConfig?: {
        url: string;
        title?: string;
        image: string;
    };
    dealerName?: string;
    dealerBadge?: {
        name: string;
        type: BadgeType;
    };
    className?: string;
}

const DealerSmallBadges: React.FC<DealerSmallBadgesProps> = ({ dealerBadge, isOpineoQuality, authorizedConfig, className, dealerName }) => {
    return (<div className={className}>
        {authorizedConfig && (
            <span className="dealer-badge authorized-dealer">
                <Image
                    className="logo-authorized"
                    src={authorizedConfig.image}
                    alt={authorizedConfig.title || `${dealerName} - autoryzowany sklep`}
                    height={20}
                    loading="lazy"
                    show={true}
                /> <span className="text">{authorizedConfig.title || 'Autoryzowany sklep'}</span>
            </span>
        )}

        {isOpineoQuality && (
            <span className="dealer-badge opineo-certificate">
                <Image src={opineoCert} alt="Certyfikat Opineo" title="Certyfikat Opineo"
                    width={26} height={26} show={true}
                    loading="lazy"
                /> <span className="text">Certyfikat Opineo</span>
            </span>
        )}

        {dealerBadge && (
            <OpineoShield className="dealer-badge opineo-badge" dealerBadge={dealerBadge} />
        )}

    </div>);
};

export default DealerSmallBadges;
